export default "__VITE_ASSET__353de586__"